import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  key: null,
  values: null,
  // errors: null,
}

// sliceを生成
export const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setKey: (state, action) => {
      return {
        ...state,
        key: action.payload,
      }
    },
    submit: (state, action) => {
      return {
        ...state,
        key: action.payload.key,
        values: action.payload.values,
      }
    },
    reset: () => {
      return initialState;
    },
    // setFormErr: (state, action) => {
    //   const id = action.payload.id;
    //   const error = action.payload.error;
    //   console.log(state)
    //   return {
    //     ...state,
    //     errors: {
    //       ...state.errors,
    //       [id]: error,
    //     }
    //   }
    // }
  },
})

export const { setKey, submit, reset } = formsSlice.actions
export default formsSlice.reducer
